import _get from 'lodash/get';
import {createMoney} from '@qwentes/models';
import {createProduct} from './product.model';

export default class ProductService {
  /* @ngInject */
  constructor(HttpService, GeographyService, PRODUCT_CONSTANT) {
    this.httpService = HttpService;
    this.geographyService = GeographyService;
    this.PRODUCT_CONSTANT = PRODUCT_CONSTANT;
    this.SERVICE_PRODUCT = `${HttpService.BASE_PATH}/products`;
    this.SERVICE_PRICE = `${HttpService.BASE_PATH}/stocks_and_prices`;
    this.store = {};
    // this.isPersonalShopper = this.authService.isPersonalShopper();
  }

  query(params, {cacheable} = {}) {
    return this.httpService({
      method: 'GET',
      params,
      cacheable,
      url: this.SERVICE_PRODUCT,
    }).then(({data}) => {
      const products = data.data.map(p => createProduct(p));
      return {
        products,
        page: +data.page,
        perPage: +data.perPage,
        total: +data.total,
      };
    }, this.httpService.reject);
  }

  get(productId) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE_PRODUCT}/${productId}`,
    }).then(({data}) => createProduct(data.data), this.httpService.reject);
  }

  getStockByMarketId(marketId, productId) {
    const PATH_PRICE = `${this.SERVICE_PRICE}/stocks/markets/${marketId}/products/${productId}`;
    return this.httpService.get(PATH_PRICE).then(({data}) => {
      return data.data.map(i => this._createStock(i.attributes));
    });
  }

  _createStock(i) {
    return {
      productId: i.productId,
      quantity: i.quantity || 0,
      storeId: i.storeId,
      size: {
        ...i.productSize,
      },
    };
  }

  getBarcodePriceByStoreId(storeId, barcode) {
    const PATH_PRICE = `${this.SERVICE_PRICE}/prices/stores/${storeId}/barcodes/${barcode}`;
    return this.httpService.get(PATH_PRICE).then(({data}) => {
      const price = this._createPrice(_get(data, 'data[0].attributes', {}));
      return price || this.httpService.reject('Price not Found');
    }, this.httpService.reject);
  }

  getBarcodeEmployeePriceByStoreId(storeId, barcode) {
    const PATH_PRICE = `${this.SERVICE_PRICE}/employeePrices/stores/${storeId}/barcodes/${barcode}`;
    return this.httpService.get(PATH_PRICE).then(({data}) => {
      const price = this._createPrice(_get(data, 'data[0].attributes', {}));
      return price || this.httpService.reject('Price not Found');
    }, this.httpService.reject);
  }

  _createPrice({finalPrice} = {}) {
    return finalPrice && createMoney(finalPrice);
  }

  getAggregateStocksByMarket(productId, params = {}) {
    const PATH_PRICE = `${this.SERVICE_PRODUCT}/${productId}/aggregate_stocks/by_market`;
    return this.httpService({
      method: 'GET',
      url: PATH_PRICE,
      params,
    }).then(({data}) => data.data, this.httpService.reject);
  }

  variations(productId) {
    return this.httpService.all([
      this.httpService.get(`${this.SERVICE_PRODUCT}/${productId}/variations/modelId`),
      this.httpService.get(`${this.SERVICE_PRODUCT}/${productId}/variations/partId`),
      this.httpService.get(`${this.SERVICE_PRODUCT}/${productId}/variations/colorId`),
    ]).then((responses) => {
      return responses.reduce((arr, response) => {
        arr.push(...response.data.data.map(p => createProduct(p)));
        return arr;
      }, []);

      // return this.isPersonalShopper
      //   ? variations.filter(v => !!v.coverImage.url)
      //   : variations;
    }, this.httpService.reject);
  }

  eCommerceStock(productId, locationGroup) {
    return this.httpService({
      method: 'GET',
      url: `${this.SERVICE_PRICE}/stocks/oci-ecommerce/${locationGroup}/products/${productId}`,
    }).then(({data}) => {
      return data.data.map(i => this._createStock(i.attributes));
    }, this.httpService.reject);
  }

  errorResponse(error = {message: 'Price not found'}) {
    const hasSourceParameterError = error.source && error.source.parameter;
    const newError = (error && this.PRODUCT_CONSTANT.HTTP.ERROR_CODE[error.code]) || error.message || 'Unknown Error';
    return hasSourceParameterError && typeof newError === 'object' ? newError[error.source.parameter] : newError;
  }

  resetStore() {
    this.store = {};
  }

  storeProducts(data) {
    this.store.products = data;
  }

  storeScrollProsition(value) {
    this.store.scrollPosition = value;
  }

  storePagination(paginationObject) {
    for (const key in paginationObject) {
      if (paginationObject.hasOwnProperty(key)) {
        this.store[key] = paginationObject[key];
      }
    }
  }

  getProductDistribution(productId) {
    return this.httpService.get(`${this.httpService.BASE_PATH}/pim/catalogues/${productId}`).then(({data}) => {
      const marketIds = data.data.map(m => m.marketId).join(',');
      const config = {params: {'filter[ids]': marketIds}};
      return this.geographyService.getMarkets(config);
    }, this.httpService.reject);
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product.service.js